<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!meta.keepAlive"></router-view>
    <v-popup></v-popup>
    <msg ref="msg"></msg>
    <v-wxts></v-wxts>
    <v-bar-scan ref="zoom"></v-bar-scan>
  </div>
</template>

<script>

import VPopup from "./plugins/v-popup";
import Msg from "./plugins/msg";
import VWxts from "./plugins/v-wxts";
import VBarScan from "./plugins/v-bar-scan";

export default {
  name: "app",
  components: {VBarScan, VWxts, Msg, VPopup},
  mixins: [],
  computed: {
    meta() {
      return this.$route.meta || {};
    }
  },
  created() {
    this.$store.commit('setCurrentCompatIndex', -1);
    bus.$on('msg', (msg) => {
      this.$refs.msg.show(msg);
    })
    bus.$on("show-barcode", img => {
      this.$refs.zoom.show(img.src);
    });
  },

  mounted() {

  },
  watch: {
    async $route() {
      //await wechatService.hideAllNonBaseMenuItem(this.appid);
    }
  }
}
</script>

<style lang="scss">
@import "./common/var";
@import "./common/mixin";
@import "./common/base";
@import "./common/project";

.color_warn {
  color: #ffa200;
}

.bg_warn {
  background-color: #ffa200;
}


@supports (bottom: constant(safe-area-inset-bottom)) {
  body {
    padding-bottom: constant(safe-area-inset-bottom);
  }
}

.t45 {
  top: 45px;
}

.error-title {
  .weui-dialog__title {
    &::before {
      content: "\e61b";
      color: rgb(247, 98, 96);
      font-size: 20px;
      display: inline-block;
      margin-right: 5px;
      font-family: "iconfont";
    }
  }

  .weui-dialog p {
    text-align: left;
  }
}

#test-detail {
  .wrap {
    padding: 10px;
    background-color: white;

    h5 {
      padding: 10px 0;
      font-size: 14px;
    }

    p {
      padding: 10px;
      font-size: 13px;
      background-color: $bgColor;
      border-radius: 5px;
      color: #666666;

      table {
        table-layout: fixed;

        .fanwei {
          width: 130px;
        }
      }
    }

    .red {
      padding: 0 5px;
      color: red;
    }
  }
}

#test-detail2 {
  padding-bottom: 10px;

  .wrap {
    @include lines(6);
    margin: 10px 10px 0;
    background-color: white;
  }

  .red {
    padding: 0 5px;
    color: red;
  }
}

#article_detail {
  line-height: 1.5;
  padding-top: px2rem(15px);

  video {
    width: 100%;
    height: auto;
  }

  img {
    margin-bottom: px2rem(15px);
    width: 100%;
  }
}

#app {
  background-color: #ffffff;
}

#app,
.page {
  /*display: flex;*/
  /*flex-direction: column;*/
  overflow: hidden;
  position: absolute;
  width: 100%;
  height: 100%;
}

.notice-msg {
  margin-left: auto;
  margin-right: auto;
  margin-top: px2rem(10px);
  margin-bottom: px2rem(10px);
  border-radius: 5px;
  padding: 2px 4px;
  width: px2rem(345px - 35px * 2 - 10px * 2);
  font-size: 12px;
  color: white;
  background-color: rgb(204, 204, 204);

  span {
    color: $mainColor;
  }
}

.bullet-active {
  background-color: $mainColor;
  opacity: 1;
}

.lines {
  -webkit-box-orient: vertical;
}

.bl {
  @include border(left);
}

.br {
  @include border(right);
}

.bt {
  @include border(top);
}

.bb {
  @include border(bottom);
}

.lines2 {
  @include lines(2);
}

.border {
  border: 1px solid $borderColor;
}

.weui-icon-success {
  color: $mainColor;
}

.weui-color {
  color: #09bb07;
}

.bg2 {
  background-color: #ebf8ff;
}

.mini-btn {
  background-color: $mainColor;
  color: white;
  border-radius: 15px;

  &.bg_warn {
    background-color: #ffa200;
  }
}

.orange {
  color: #FF7824;
}
</style>



// WEBPACK FOOTER //
// src/App.vue